import React, { useState } from 'react';
import Table from '@RHEnvironmental/pattern-library/dist/js/components/Table';
import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import Icon from '@RHEnvironmental/pattern-library/dist/js/components/RheIcon';
import BodyText from '../BodyText';
import { UNSUPPORTED_HAZARD_IDS } from '../../../constants/hazards';

const HazardScoringList = ({
    HHSRSScoring,
    onEditScoring,
    isInspectionCreator,
}) => {
    const [expandedHazard, setExpandedHazard] = useState(false);

    const getBandClasses = (band) =>
        getClassNames('scoring__band', {
            'scoring__band--unscored': !band,
        });

    const isUnsupported = (hazard) =>
        UNSUPPORTED_HAZARD_IDS.indexOf(hazard.id) !== -1;

    const isHazardExpanded = (hazard) => expandedHazard?.id === hazard.id;

    return (
        <>
            {HHSRSScoring && (
                <Table className="table--full-width scoring__table">
                    <thead>
                        <tr>
                            <th>Hazard</th>
                            <th>Score</th>
                            <th>Rating</th>
                            <th>Category</th>
                        </tr>
                    </thead>
                    <tbody>
                        {HHSRSScoring.map((hazard) => (
                            <>
                                <tr
                                    key={hazard.id}
                                    onClick={() => {
                                        setExpandedHazard(hazard);
                                    }}
                                    className={
                                        hazard.scoring?.requires_rescore &&
                                        'row-has-warning'
                                    }
                                >
                                    <td data-th="">{hazard.name}</td>
                                    <td data-th="">
                                        <span>
                                            {hazard.scoring?.score
                                                ? Number(
                                                      hazard.scoring.score
                                                  ).toFixed(1)
                                                : ''}
                                        </span>

                                        {hazard.scoring?.requires_rescore && (
                                            <span>
                                                <Icon
                                                    icon="linear exclamation"
                                                    foregroundColor="#ff0000"
                                                    altText="This hazard may need review"
                                                />
                                            </span>
                                        )}
                                    </td>
                                    <td data-th="">
                                        {isUnsupported(hazard) ? (
                                            <span>Coming soon</span>
                                        ) : (
                                            <span
                                                className={getBandClasses(
                                                    hazard.scoring?.band
                                                )}
                                            >
                                                {hazard.scoring
                                                    ? `Band ${hazard.scoring.band}`
                                                    : 'Incomplete'}
                                            </span>
                                        )}
                                    </td>
                                    <td data-th="">
                                        {hazard.scoring
                                            ? hazard.scoring.category
                                            : ''}
                                    </td>
                                </tr>
                                {isHazardExpanded(hazard) && (
                                    <tr
                                        key={`expanded-${hazard.id}`}
                                        className="scoring__row--expanded"
                                    >
                                        <td>
                                            <div>
                                                <PageHeading
                                                    level={4}
                                                    className="mt-2"
                                                >
                                                    Likelihood Justification
                                                </PageHeading>
                                                <BodyText>
                                                    {hazard.scoring
                                                        ?.likelihood_justification ??
                                                        '—'}
                                                </BodyText>
                                                <PageHeading level={4}>
                                                    Spread of Harms
                                                    Justification
                                                </PageHeading>
                                                <BodyText>
                                                    {hazard.scoring
                                                        ?.harms_justification ??
                                                        '—'}
                                                </BodyText>
                                            </div>

                                            {!isUnsupported(hazard) &&
                                                isInspectionCreator && (
                                                    <div className='mb-2'>
                                                        <Button
                                                            onClick={() =>
                                                                onEditScoring(
                                                                    hazard
                                                                )
                                                            }
                                                        >
                                                            Edit Scoring
                                                        </Button>
                                                        </div>
                                                )}
                                        </td>
                                    </tr>
                                )}
                            </>
                        ))}
                    </tbody>
                </Table>
            )}
        </>
    );
};

export default HazardScoringList;
